import { render, staticRenderFns } from "./AddReceiptType.vue?vue&type=template&id=2b982335&scoped=true&"
import script from "./AddReceiptType.vue?vue&type=script&lang=js&"
export * from "./AddReceiptType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b982335",
  null
  
)

export default component.exports